module.exports = __webpack_public_path__ + "static/media/website-bearbnb.54a7ce6e.png";